"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FAQ() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const faqs = [{
    id: "faq-1",
    question: "What is Pass the Plate?",
    answer: "Pass the Plate is our monthly supper club experience featuring intimate, ticketed dinners with curated menus that change every month. It's designed to bring people together and create community through shared food experiences in a warm, inviting setting."
  }, {
    id: "faq-2",
    question: "What is Create the Plate?",
    answer: "Create the Plate is our hands-on cooking class series where we demystify cooking techniques and make culinary skills approachable and fun. Each small class offers personalized instruction, allowing you to learn at your own pace in an interactive environment."
  }, {
    id: "faq-3",
    question: "Where are the events held?",
    answer: "All of our events take place in Los Angeles, CA. Specific venue details are shared with ticket holders prior to each Pass the Plate dinner or Create the Plate class."
  }, {
    id: "faq-4",
    question: "How do I purchase tickets?",
    answer: "Tickets for both Pass the Plate dinners and Create the Plate classes can be purchased through our website. We recommend booking early as our intimate settings have limited capacity and often sell out quickly."
  }, {
    id: "faq-5",
    question: "Do you accommodate dietary restrictions?",
    answer: "We do our best to accommodate dietary restrictions and allergies. Please let us know your needs when booking, and we'll work with you to ensure you have a wonderful experience at our table."
  }, {
    id: "faq-6",
    question: "What should I expect at a cooking class?",
    answer: "Our Create the Plate classes are small, hands-on experiences where you'll learn practical cooking techniques step-by-step. Chef Jess provides personalized instruction throughout, making cooking approachable, fun, and educational for all skill levels."
  }];
  return <section id="faq" ref={ref} className={`py-24 px-6 bg-background transition-all duration-[var(--duration-slow)] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground">
            Everything you need to know about our supper clubs and cooking classes
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border border-border rounded-lg px-6 bg-background shadow-soft hover:shadow-medium transition-shadow duration-[var(--duration-medium)]">
              <AccordionTrigger className="text-lg font-semibold text-foreground hover:text-primary hover:no-underline py-6 group">
                <span className="relative">
                  {faq.question}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-[var(--duration-medium)] group-hover:w-full" />
                </span>
              </AccordionTrigger>
              <AccordionContent className="relative text-muted-foreground leading-relaxed">
                <div className="absolute inset-0 opacity-5 pointer-events-none bg-[radial-gradient(ellipse_at_center,_var(--color-primary)_0%,_transparent_70%)]" />
                <div className="relative z-10 animate-fade-in-up">
                  {faq.answer}
                </div>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}